var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticStyle:{"max-width":"20rem"},attrs:{"img-src":_vm.sponsorsImage,"img-alt":"Image","img-top":"","tag":"article"}})}
var staticRenderFns = []

export { render, staticRenderFns }